import { __read } from 'tslib';
import * as React from 'react';
import throttle from 'lodash/throttle';
import { isServer } from './utils.esm.js';

var THROTTLE_DELAY = 100;
var smallMin = 375;
var mediumMin = 720;
var largeMin = 1020;
var extraLargeMin = 1260;
var WindowBreakpoints = {
    extraLargeMin: extraLargeMin,
    largeMin: largeMin,
    mediumMin: mediumMin,
    smallMin: smallMin,
};
var macBookPro16ScreenSize = {
    height: 1920,
    width: 3072,
};
//function to get windows size
// defaults to MacBook size if document is not defined for SSR
var getWindowDimensions = function () { return ({
    height: !isServer() && document ? document.documentElement.clientHeight : macBookPro16ScreenSize.height,
    width: !isServer() && document ? document.documentElement.clientWidth : macBookPro16ScreenSize.width,
}); };
var ScreenSize;
(function (ScreenSize) {
    ScreenSize["ExtraSmall"] = "ExtraSmall";
    ScreenSize["Small"] = "Small";
    ScreenSize["Medium"] = "Medium";
    ScreenSize["Large"] = "Large";
    ScreenSize["ExtraLarge"] = "ExtraLarge";
})(ScreenSize || (ScreenSize = {}));
var WindowDimensionsContext = React.createContext(null);
var DimensionsProvider = function (_a) {
    var _b;
    var children = _a.children;
    var _c = __read(React.useState(getWindowDimensions()), 2), windowDimensions = _c[0], setWindowDimensions = _c[1];
    //function to attach to the useEffect's window.addEventListener
    var handleResize = React.useCallback(function () {
        setWindowDimensions(getWindowDimensions());
    }, []);
    React.useEffect(function () {
        //listen to window resize
        var throttledHandleResize = throttle(handleResize, THROTTLE_DELAY);
        window.addEventListener('resize', throttledHandleResize);
        //clear listener on component unmount
        return function () { return window.removeEventListener('resize', throttledHandleResize); };
    }, []);
    var dimensionMapping = (_b = {},
        _b[ScreenSize.ExtraSmall] = windowDimensions.width < smallMin,
        _b[ScreenSize.Small] = windowDimensions.width >= smallMin && windowDimensions.width < mediumMin,
        _b[ScreenSize.Medium] = windowDimensions.width >= mediumMin && windowDimensions.width < largeMin,
        _b[ScreenSize.Large] = windowDimensions.width >= largeMin && windowDimensions.width < extraLargeMin,
        _b[ScreenSize.ExtraLarge] = windowDimensions.width >= extraLargeMin,
        _b);
    // there is no other way to do handle typescript here
    var keys = Object.keys(dimensionMapping);
    var screenSize = keys.find(function (k) { return dimensionMapping[k]; });
    return (React.createElement(WindowDimensionsContext.Provider, { value: screenSize ? ScreenSize[screenSize] : null }, children));
};

export { ScreenSize, WindowBreakpoints, WindowDimensionsContext, DimensionsProvider as default };
//# sourceMappingURL=WindowDimensionProvider.esm.js.map
